module.exports = __webpack_public_path__ + "img/logo.f4fa12b0.png";